// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-text {
  color: rgba(33, 43, 35, 0.3);
  margin-top: -200px;
}

.navbar-content .loader-animation {
  transform: translateY(-150px) translateX(-250px) !important;
}

.loader-animation {
  transform: translateY(-150px);
  width: 200px !important;
  height: 200px !important;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/shared/loader/loader.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,kBAAA;AACF;;AAEA;EACE,2DAAA;AACF;;AAEA;EACE,6BAAA;EACA,uBAAA;EACA,wBAAA;AACF","sourcesContent":[".loader-text {\n  color: rgba(33, 43, 35, 0.3);\n  margin-top: -200px;\n}\n\n.navbar-content .loader-animation {\n  transform: translateY(-150px) translateX(-250px) !important;\n}\n\n.loader-animation {\n  transform: translateY(-150px);\n  width: 200px !important;\n  height: 200px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
